"use client"

import { WineOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WineOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WineOffIcon = component(Icon)({ as: WineOff })
